module.exports = __webpack_public_path__ + "img/top2.a73e2704.png";